import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import TimePicker from 'react-times';
import 'react-times/css/classic/default.css';
import FormSection from '../formSection';
import localization from 'assets/localization/localization';
import ConstantInput from 'components/sales/Input/constantInput/constantInput';
import DatePicker from 'components/sales/datePicker/datePicker';
import DropDownInput from 'components/sales/Input/dropDownInput/dropDownInput';
import { FormGroup } from 'react-bootstrap';
import { handleValidateObj } from 'constants/objValues/objvalues';
import { handleFormatDate } from 'constants/dateFormat/dateFormat';
import Regex from 'services/utils/regex/Regex';

const ParkingRules = ({ data, handleValue, prefilledData, isApartment = false }) => {
  const { overnightParkingAllowed, twoWheelersAllowedToParkWithCars } = data;
  const parkingObj = {
    overnight: '',
    twowheelers: '',
    paneltylosing: '',
    anyOther: '',
    marketingReq: '',
    expectedLive: '',
    parkingRulePenalty: '',
  };

  const [parkData, setParkData] = useState(parkingObj);
  const [toTime, setToTime] = useState(
    `${new Date().getHours()}:${new Date().getMinutes()}`
  );
  const [fromTime, setFromTime] = useState(
    `${new Date().getHours()}:${new Date().getMinutes()}`
  );
  const [overAllowed, setOverAllowed] = useState();
  const [twoAllowed, setTwoAllowed] = useState();
  useEffect(() => {
    const parkingdtl = {
      parkingRulePenalty: parkData?.parkingRulePenalty,
    };
    // const formatLiveDate = handleFormatDate(new Date());
    // if (isApartment === false) {
    //   parkingdtl.expectedLive = formatLiveDate;
    // }
    const isNotEmpty = handleValidateObj(parkingdtl);
    if (isNotEmpty !== false) {
      const obj = {
        ...parkingdtl,
        overnight: parkData.overnight,
        twowheelers: parkData.twowheelers,
        toTime: toTime,
        fromTime: fromTime,
        paneltylosing: parkData.paneltylosing,
        anyOther: parkData.anyOther,
        marketingReq: parkData.marketingReq,
      };
      if (isApartment === true) {
        obj.expectedLive = '';
      }
      handleValue(obj);
    } else {
      handleValue(null);
    }
  }, [parkData]);

  useEffect(() => {
    if (
      prefilledData?.parking_rules !== undefined &&
      prefilledData?.parking_rules !== null
    ) {
      const {
        end_time,
        other_rule,
        overnight_parking_allowed,
        start_time,
        two_wheeler_allowed_with_car
      } = prefilledData?.parking_rules;

      setOverAllowed(overnight_parking_allowed === '1' ? 'Yes' : 'No');
      setTwoAllowed(two_wheeler_allowed_with_car === '1' ? 'Yes' : 'No');
      setToTime(end_time);
      setFromTime(start_time);
      setTimeout(() => {
        setParkData({ 
          ...parkData,
          overnight: overnight_parking_allowed,
          twowheelers: two_wheeler_allowed_with_car,
          // paneltylosing: parkData.paneltylosing,
          anyOther: (other_rule != 'undefined' ? other_rule : ''),
          // marketingReq: parkData.marketingReq,
        });
      }, 100);
    }
  }, [prefilledData]);

  const onFromTimeChange = (options) => {
    const { hour, minute } = options;
    setFromTime(`${hour}:${minute}`);
  };

  const onToTimeChange = (options) => {
    const { hour, minute } = options;
    setToTime(`${hour}:${minute}`);
  };

  return (
    <FormSection title={localization.parkingRules}>
      <DropDownInput
        data={overnightParkingAllowed}
        label={localization.overnight}
        errorMsg={localization.requiredovernight}
        getIdValue={(val) => setParkData({ ...parkData, overnight: val.id })}
        value={overAllowed}
      />
      <DropDownInput
        data={twoWheelersAllowedToParkWithCars}
        label={localization.twowheelers}
        getIdValue={(val) => setParkData({ ...parkData, twowheelers: val.id })}
        errorMsg={localization.requiredtwowheelers}
        value={twoAllowed}
      />
      <FormGroup>
        <label>{localization.fromTime}</label>
        <TimePicker
          theme="classic"
          timeFormat="hh:mm"
          timeMode={24}
          time={fromTime}
          onTimeChange={onFromTimeChange}
          value={fromTime}
        />
      </FormGroup>
      <FormGroup>
        <label>{localization.toTime}</label>
        <TimePicker
          theme="classic"
          timeFormat="hh:mm"
          timeMode={24}
          time={toTime}
          onTimeChange={onToTimeChange}
          value={toTime}
        />
      </FormGroup>

      <ConstantInput
        label={localization.PaneltyLosing}
        handleChange={(val) =>
          setParkData({
            ...parkData,
            paneltylosing: val,
            parkingRulePenalty: val,
          })
        }
        type="number"
        errorMsg={localization.requiredPaneltyLosing}
      />
      <ConstantInput
        label={localization.anyOther}
        handleChange={(val) => setParkData({ ...parkData, anyOther: val })}
        value={parkData.anyOther}
      />
      <ConstantInput
        label={localization.marketingReq}
        handleChange={(val) => setParkData({ ...parkData, marketingReq: val })}
        errorMsg={localization.requiredmarketingReq}
      />

      {/* <ConstantInput
        label={localization.parkingRulePenalty}
        handleChange={(val) =>
          setParkData({ ...parkData, parkingRulePenalty: val })
        }
        regex={Regex.numeric.test(parkData?.parkingRulePenalty)}
        errorMsg={
          parkData?.parkingRulePenalty.length > 0
            ? localization.numericError
            : localization.isRequired
        }
        maxLength={3}
        minLength={3}
      /> */}
      {/* {isApartment ? null : (
        <DatePicker
          label={localization.expectedLive}
          required={false}
          handleChange={(val) =>
            setParkData({ ...parkData, expectedLive: val })
          }
          minimumDate={new Date()}
        />
      )} */}
    </FormSection>
  );
};

ParkingRules.propTypes = {
  data: PropTypes.any,
  handleValue: PropTypes.func,
};

export default ParkingRules;
